/**
 * Returns true if the value is an un-replaced build-time sentinel
 * (e.g. __SENTINEL_NEXT_PUBLIC_GATEWAY_URL__).
 *
 * Next.js inlines NEXT_PUBLIC_* values at build time. In the stage/main Docker
 * images, real values come from Bitwarden Secrets Manager and are only available
 * at container start. The entrypoint.sh replaces the sentinel strings at that
 * point — but if .env.local is absent (e.g. the Docker secret was not mounted),
 * the sentinel strings remain in the bundle and must be treated as missing.
 *
 * Use this guard in any component or util that reads a NEXT_PUBLIC_* var that
 * has a Dockerfile sentinel — see docs/next-public-env-sentinel-pattern.md.
 */
export const isSentinelValue = (v: string | undefined): boolean => typeof v === "string" && v.startsWith("__SENTINEL_");
